/* @flow */
import LoadingIndicator from 'components/LoadingIndicator';
import Notice from 'components/Notice';
import OrganizationActions from 'actions/OrganizationActions';
import * as React from 'react';
import Table from 'components/Table';
import { capitalize } from 'lodash';

type Props = {
  orgId: Backbone$Id,
  // TODO: require value for timeWindow when admin stats v1 is deprecated
  timeWindow?: string,
  // TODO: remove when admin stats v1 is deprecated
  messageType: string,
  actionRow?: React.Node,
};

type School = {
  announcement_count: number,
  name: string,
  school_id: string,
  user_count: number,
};

type State = {
  activeSchools: Array<School>,
  error: ?Error,
};

class AdminActiveSchoolsTable extends React.Component<Props, State> {
  componentDidMount() {
    const { orgId, timeWindow } = this.props;

    OrganizationActions.getActiveSchools(orgId, timeWindow)
      .then(activeSchools => this.setState({ activeSchools }))
      .catch(error => this.setState({ error, activeSchools: [] }));
  }

  render() {
    const { messageType, actionRow } = this.props;

    const placeholderHeight = 100;

    if (!this.state || !this.state.activeSchools) {
      return <LoadingIndicator height={placeholderHeight} size="small" />;
    }

    if (this.state.error || this.state.activeSchools.length === 0) {
      return (
        <Notice color="white" height={placeholderHeight}>
          Sorry—no statistics are available for your district yet.
        </Notice>
      );
    }

    return (
      <Table
        head={
          <tr>
            <th>School</th>
            <th>{capitalize(messageType)} sent</th>
            <th>Active teachers</th>
          </tr>
        }
        className="AdminActiveSchoolsTable">
        <tbody>
          {this.state.activeSchools.map(school => {
            return (
              <tr key={school.school_id}>
                <td>{school.name}</td>
                <td>{school.announcement_count}</td>
                <td>{school.user_count}</td>
              </tr>
            );
          })}
          {actionRow && (
            <tr>
              <td colSpan={3}>{actionRow}</td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }
}
export default AdminActiveSchoolsTable;
